import { GAME_VARIABLES } from "../../../constants";
import { StarParticles } from "../starsBackground";

export class Chunk6 {
  constructor(scene: Phaser.Scene) {
    const sprite1 = scene.add.sprite(
      0,
      GAME_VARIABLES.IS_RESTART ? 0 : -30,
      "atlas",
      "background_chunk6/gradient"
    );

    if (!GAME_VARIABLES.IS_RESTART) {
      scene.add.tween({
        targets: sprite1,
        y: `+=30`,
        duration: 3000,
        ease: "Sine.easeInOut",
      });
    }

    sprite1.setDepth(-5);

    sprite1.setActive(false);

    new StarParticles(scene);
  }
}
